<ng-container>
  <app-get-offers-button
    [tabName]="tabName"
    [resourceId]="resourceId"
    [recordId]="recordId?.[0]"
    [fgTitle]="title"
    [isbn]="isbn"
  ></app-get-offers-button>
</ng-container>
